var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"overview-header"},[_c('h2',[_vm._v(_vm._s(_vm.$t("message.sidebar.message.overview")))]),(_vm.criarCampanha)?_c('app-advertising-modal'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }